import React, {useEffect, useState} from 'react';
import '../App.css';
import { Form } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import Axios from 'axios';
import { Hint } from 'react-autocomplete-hint';
import Bodyheaderloged from './bodyheaderloged'
import io from 'socket.io-client';
import qz from 'qz-tray';
import Grillaboordersreports from './grillaboordersreports'

// La URL en la que IIS redirige la solicitud hacia el servidor Socket.IO
const socket = io(process.env.REACT_APP_URLSOCKETIO, {
    transports: ['websocket']
});

socket.on('connect', () => {
    console.log('Conectado a Socket.IO');
});

socket.on('message', (data) => {
    console.log('Mensaje recibido:', data);
});

function Bodygestioncomandas (props){
    const [datosComandaDB, setDatosComandaDB] = useState([]);
    const [datosDetalleComandaDB, setDatosDetalleComandaDB] = useState([]);
    const [comandaSeleccionada, setComandaSeleccionada] = useState(null); 
    const [audioHabilitado, setAudioHabilitado] = useState(true);
    const [activo, setActivo] = useState(false);
    // Lista de estados
    const estadosComanda = [
        { id: '2', nombre: 'Confirmada con pago' },
        { id: '3', nombre: 'En preparacion' },
        { id: '4', nombre: 'Entregada' }
    ];
    
    const habilitarAudio = () => {
        const dummy = new Audio();
        dummy.play().catch(() => {});
        setAudioHabilitado(true);
    };

    const toggle = () => {
        setActivo(!activo);
        habilitarAudio(); // tu función
    };
    
    const comandasList = datosComandaDB.map((item, i) => 
        <div  key={i} class="card bg-white shadow-lg rounded-lg p-4 hover:shadow-xl" onClick={() => {getDetalleComanda(item);
        }} >
            <h3 class="text-xl font-bold text-blue-800">Comanda {item.comanda_id}</h3>
            <p class="text-sm text-gray-600">Usuario: {item.usuario}</p>
            <p class="text-sm text-gray-600">Nombre: {item.apoderado}</p>
            <p class="text-sm text-gray-600">Fecha de entrega: {item.fecha ? item.fecha.slice(0, 10) : "Sin programación de entrega"}</p>
            <p class="text-sm text-gray-600">Hora de entrega: {item.hora ? item.hora : "Sin programación de entrega"}</p>
            <p class="text-sm text-gray-600">Fecha de creacion: {item.fecha_creacion ? item.fecha_creacion.slice(0, 10): "Sin fecha definida"}</p>
            <p class="text-sm text-gray-600">Hora de creacion: {item.hora_creacion ? item.hora_creacion : "Sin hora definida"}</p>
            <p class="text-sm text-gray-600">Estado: {item.estado}</p>
            <p class="text-sm text-gray-600"><Button onClick={() => printComanda(item)}>Imprimir</Button></p>
        </div>
    );

    const GetComandas = () =>
    {    
        let idcasinouserfront = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
            
        Axios.get(process.env.REACT_APP_URLGETCOMANDA, {
            params: {
                casino_id: idcasinouserfront,
                comanda_estado: '2'
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {        
            setDatosComandaDB(response.data.comandas)
        }).catch(error => {
            return error     
        });
    }    

    const getDetalleComanda = (item) =>
    {      
        setComandaSeleccionada(item); // Establece la comanda seleccionada    
        Axios.get(process.env.REACT_APP_URLGETCOMANDADETALLE, {
            params: {
                comanda_id: item.comanda_id
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {     
            setDatosDetalleComandaDB(response.data.detalle_comanda)
        }).catch(error => {
            return error     
        });        
    }    

    const handleEstadoChange = (e) => {
        const nuevoEstadoId = e.target.value;  // Obtienes el id del estado seleccionado
        const estadoSeleccionado = estadosComanda.find(estado => estado.id === nuevoEstadoId); // Encuentra el estado correspondiente
        
        // Si el estado seleccionado existe, actualizamos el estado de la comanda
        if (estadoSeleccionado) {
            setComandaSeleccionada(prevState => ({
                ...prevState,            // Mantén los otros valores de comandaSeleccionada
                estado_id: estadoSeleccionado.id,  // Actualiza solo el id del estado
                estado: estadoSeleccionado.nombre // Actualiza el nombre del estado también
            }));

            //Aca se actualiza la comanda en la base de datos cuando el estado
            //es igual a 3

        }
    };

    const actualizarEstadoComanda = (comanda_id, estado_id) => {

        //const datos = {
            //fecha: comanda.fecha,
            //hora: comanda.hora
        //};
          
        // Paso 1: Combinar fecha (sin la "hora") con hora
        //const fechaParte = datos.fecha.slice(0, 10); // "2025-04-22"
        //const fechaHoraStr = `${fechaParte}T${datos.hora}`; // "2025-04-22T17:40:00"
          
        // Paso 2: Crear objeto Date con eso
        //const fechaHora = new Date(fechaHoraStr);
          
        // Paso 3: Comparar con la fecha y hora actual
        //const ahora = new Date()

        //if (fechaHora <= ahora) {
            //console.log("La fecha y hora es igual o menor que ahora.");
        //} 
        //else 
        //{
           // console.log("La fecha y hora es futura.");
        //}


        Axios.put(process.env.REACT_APP_URLACTUALIZARESTADOCOMANDA, {
            comanda_id: comanda_id,
            estado_id: estado_id
        }, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST, PUT',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {   
            if (response.status === 200) {
                if (estado_id === '4') {
                    printComanda();  // Imprimir si está entregada
                }
                setComandaSeleccionada(null)
                GetComandas()
            }
            else{
                setComandaSeleccionada(null)
                GetComandas()
            }     
        }).catch(error => {
            console.log(error)     
        });        
    };

    useEffect(() => {
        // Escuchar el evento "nueva_comanda" emitido por el servidor
        socket.on('Nueva_comanda', (data) => {
            //Verificar casino
            let idcasinouserfront = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
            if(data.casino_id == idcasinouserfront)
            {
                console.log("Verificado el casino la comanda es: " +   data)    
                const newComanda = {
                    comanda_id: data.comanda_id,
                    fecha: new Date(data.fecha).toLocaleDateString(),
                    hora: data.hora,
                    estado: data.estado,
                    casino_id: data.casino_id,
                    casino: data.casino,
                    usuario: data.usuario,
                    apoderado: data.apoderado,
                    fecha_creacion: data.fecha_creacion,
                    hora_creacion: data.hora_creacion
                };

                let idcasinouserfront = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
                console.log("Usuario socket:" + data.mail_imp)
                console.log("Usuario front:" + idcasinouserfront.replace('"', ''))
                if (data.mail_imp == idcasinouserfront.replace('"', ''))
                {
                    console.log("Audio Habilitado? :" + audioHabilitado)
                    if (audioHabilitado) {
                        const sonido = new Audio('/sounds/print-notification.mp3');
                        sonido.play().catch(err => console.error("No se pudo reproducir sonido:", err));
                    }else
                    {
                        console.log("No se pudo reproducir sonido")   
                    }
                    //Imprime la comanda
                    console.log("Llama funcion imprimir")
                    //printComanda(data);
                    enqueuePrint(data);
                }
                // Actualizar el estado de datosComandaDB y agregar la nueva comanda al inicio del array
                setDatosComandaDB(prevComandas => [newComanda, ...prevComandas]);                
                //Aca debemos pintar el contenido de la comanda
                //en el componente que corresponde.
                console.log("Mensaje recibido:", data);  // Verifica que data tenga el formato correcto
    
                // Asegúrate de que los datos estén correctamente estructurados
                //alert(`Comanda Creada: ID ${data.message} ${data.comanda_id} `);                
            }
    
        });    
        return () => {
            socket.off('Nueva_comanda');
        };
    }, []);

    useEffect(() => {
        GetComandas()
    }, []);


    const printComanda = async (e) => {
        //console.log("Verificado el usuario comanda_id: " + e.comanda_id)
        if (!e || e.estado_id == '4') return;
        
        //getDetalleComanda(e);
        //console.log("Verificado el usuario2:" + datosDetalleComandaDB)
        let detalleComanda = [];
        //Obtiene impresora del backoffice
        let impresora = window.localStorage.getItem('MY_APP_STATE_PROF_IMPRESORA').replace('"', '')
        try {
            const response = await Axios.get(process.env.REACT_APP_URLGETCOMANDADETALLE, {
                params: {
                    comanda_id: e.comanda_id
                },
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type'
                }
            });
    
            detalleComanda = response.data.detalle_comanda;
    
        } catch (err) {
            console.error("Error al obtener detalle:", err);
            return;
        }



        ///console.log("Detalle comanda: " + detalleComanda)
        ///const margen = '    ';
        ///const anchoColumna = 30;
        //const detalle = detalleComanda.map(
            //(item) => `${item.nombre_producto} x ${item.cantidad_producto}`
        //).join('\n');

        const ESC = '\x1B';
        const GS = '\x1D';
        const bold_on = ESC + 'E' + '\x01';
        const bold_off = ESC + 'E' + '\x00';
        const double_height_width_on = GS + '!' + '\x11';
        const double_off = GS + '!' + '\x00';
        const align_center = ESC + 'a' + '\x01';
        const align_left = ESC + 'a' + '\x00';
        const cut_paper = GS + 'V' + '\x00';
        const cortar = '\x1D\x56\x41\x10';
        const avanceFinal = '\n\n\n\n';

        const maxChar = 15;

        // Encabezado con títulos en negrita
        let detalle = `${bold_on}${'Producto'.padEnd(maxChar)} ${'Categoria'.padEnd(maxChar)} ${'Cantidad'.padEnd(maxChar)}${bold_off}\n`;
        detalle += `${'-'.repeat(maxChar)} ${'-'.repeat(maxChar)} ${'-'.repeat(maxChar)}\n`;

        // Cuerpo de productos
        detalle += detalleComanda.map(item => {
            const producto = item.nombre_producto || '';
            const categoria = item.categoria || '';
            const cantidad = String(item.cantidad_producto || '');

            const prodLines = producto.match(new RegExp(`.{1,${maxChar}}`, 'g')) || [''];
            const catLines = categoria.match(new RegExp(`.{1,${maxChar}}`, 'g')) || [''];
            const cantLines = cantidad.match(new RegExp(`.{1,${maxChar}}`, 'g')) || [''];

            const maxLines = Math.max(prodLines.length, catLines.length, cantLines.length);

            let lines = '';
            for (let i = 0; i < maxLines; i++) {
                const p = (prodLines[i] || '').padEnd(maxChar);
                const c = (catLines[i] || '').padEnd(maxChar);
                const q = (cantLines[i] || '').padEnd(maxChar);
                lines += `${p} ${c} ${q}\n`;
            }

            return lines;
        }).join('\n');

        const fechaEntregaFormat = new Date(e.fecha).toLocaleDateString();
        const now = new Date();
        const fecha = now.toLocaleDateString();
        const hora = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });


        //const detalle = detalleComanda.map(item => {
            //const desc = item.nombre_producto.padEnd(anchoColumna); // ajusta ancho
            //const cant = `x ${item.cantidad_producto}`;
            //return `${margen}${desc}${cant}`;
        //}).join('\n');
        //console.log(detalle)
        //const now = new Date();
        //const fecha = now.toLocaleDateString(); // Ej: "23/06/2025"
        //const hora = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); // Ej: "14:30"
        
        //const ESC = '\x1B';
        //const GS = '\x1D';

        // Comandos útiles
        //const bold_on = ESC + 'E' + '\x01';
        //const bold_off = ESC + 'E' + '\x00';
        //const double_height_width_on = GS + '!' + '\x11'; // 2x width & height
        //const double_off = GS + '!' + '\x00';
        //const align_center = ESC + 'a' + '\x01';
        //const align_left = ESC + 'a' + '\x00';
        //const cut_paper = GS + 'V' + '\x00';

        //const cortar = '\x1D\x56\x41\x10'; // Corte parcial ESC/POS
        //const avanceFinal = '\n\n\n\n';   // Avance extra para evitar cortes incompletos
        //const fechaEntregaFormat = new Date(e.fecha).toLocaleDateString()
        

        const contenido = `
    ${align_center}${bold_on}${double_height_width_on}COMANDA NRO. ${e.comanda_id}${double_off}${bold_off}
    
    ${align_left}${bold_on}Cliente:  ${e.apoderado}${bold_off}
    ${align_left}${bold_on}Estado :  ${e.estado}${bold_off}

${detalle}
    
    ${align_left}Fecha de entrega:  ${fechaEntregaFormat}
    ${align_left}Hora de entrega :  ${e.hora}   
    ${avanceFinal}${cortar}
    `;
    
        try {
            await qz.websocket.connect()
            .then(()=>console.log("Q Tray Conectado"))
            .catch("Error en al conectar Q Tray" + console.error);
            
            console.log("Impresora en la cual saldra la comanda: " + impresora.replace('"', ''))

            const config = qz.configs.create(impresora.replace('"', ''));
    
            const data = [{
                type: 'raw',
                format: 'plain',
                data: contenido
            }];
    
            await qz.print(config, data);
            await qz.websocket.disconnect();
    
            console.log("Impresión realizada correctamente.");
        } catch (err) {
            console.error("Error al imprimir:", err);
        }
    };

    const printQueue = [];
    let isPrinting = false;

    const processPrintQueue = async () => {
        if (isPrinting || printQueue.length === 0) return;

        isPrinting = true;
        const nextData = printQueue.shift();

        try {
            await printComanda(nextData);
        } catch (err) {
            console.error("Error en impresión:", err);
        } finally {
            isPrinting = false;
            processPrintQueue(); // Llamada recursiva para continuar con la siguiente
        }
    };

    const enqueuePrint = (data) => {
        printQueue.push(data);
        processPrintQueue();
    };

    return (
        <div className='w-full'>
            <div className='flex justify-start w-full'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP}/>
            </div>

            <div className='flex flex-col lg:flex-row w-full p-5 space-x-5 lg:space-x-10 space-y-5 lg:space-y-0'>
                <div class="flex-1 bg-white rounded-lg shadow-md overflow-hidden min-h-[600px] max-h-[600px] overflow-y-auto">

                    <div className="w-full px-5 py-2 bg-yellow-100 flex items-center justify-between">
                        <span className="text-gray-800 font-medium">Notificaciones de sonido</span>
                        <div
                        onClick={toggle}
                        className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition-colors ${
                            activo ? "bg-green-500" : "bg-gray-300"
                        }`}
                        >
                        <div
                            className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform ${
                            activo ? "translate-x-6" : "translate-x-0"
                            }`}
                        />
                        </div>                        
                    </div>
                    <div class="p-4 bg-blue-600 text-white text-lg font-semibold">
                        Notificaciones de Comandas
                    </div>


                    <div class="space-y-4 p-4">
                        {comandasList}
                    </div>
                </div>


                <div class="flex-1 bg-white rounded-lg shadow-md p-5 min-h-[600px] max-h-[600px] overflow-y-auto">

                    <div class="text-lg font-semibold text-gray-700 mb-4">Detalles de Comanda</div>
                    

                    {comandaSeleccionada && (
                        <div id="comandaForm" className="space-y-4">
                            {/* ID de la comanda */}
                            <div>
                                <label htmlFor="comanda_id" className="block text-sm font-medium text-gray-600">ID de Comanda</label>
                                <input type="text" id="comanda_id" name="comanda_id" className="w-full p-2 border rounded-md bg-gray-50 text-gray-800" value={comandaSeleccionada.comanda_id} readOnly />
                            </div>

                            {/* Fecha */}
                            <div>
                                <label htmlFor="fecha" className="block text-sm font-medium text-gray-600">Fecha de entrega</label>
                                <input type="text" id="fecha" name="fecha" className="w-full p-2 border rounded-md bg-gray-50 text-gray-800" 
                                    value={
                                        comandaSeleccionada.fecha
                                          ? comandaSeleccionada.fecha.slice(0, 10)
                                          : "Sin programación de entrega"
                                    } 
                                    readOnly />
                            </div>

                            {/* Hora */}
                            <div>
                                <label htmlFor="hora" className="block text-sm font-medium text-gray-600">Hora de entrega</label>
                                <input type="text" id="hora" name="hora" className="w-full p-2 border rounded-md bg-gray-50 text-gray-800" 
                                value={
                                    comandaSeleccionada.hora
                                    ? comandaSeleccionada.hora
                                    : "Sin programación de entrega"
                                }
                                readOnly />
                            </div>

                            {/* Estado */}
                            <div className="flex items-center gap-2">
                                {/* Select para elegir el estado */}
                                <label htmlFor="estado" className="block text-sm font-medium text-gray-600">Estado</label>
                                <select
                                    value={comandaSeleccionada.estado_id} // Usar el estado para controlar el valor seleccionado
                                    onChange={handleEstadoChange} // Función para manejar el cambio
                                >
                                    {estadosComanda.map((estado) => (
                                        <option key={estado.id} value={estado.id}>
                                            {estado.nombre}
                                        </option>
                                    ))}
                                </select>
                                
                                {/* Botón para actualizar el estado */}
                                <button
                                    onClick={() => actualizarEstadoComanda(comandaSeleccionada.comanda_id, comandaSeleccionada.estado_id, comandaSeleccionada)}
                                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                >
                                    Actualizar Comanda
                                </button>
                            </div>

                            {/* Grilla de detalles de la comanda */}
                            <div className="mt-5">
                                <h4 className="text-lg font-semibold text-gray-700">Detalles de los productos</h4>
                                <table className="min-w-full mt-3">
                                    <thead>
                                        <tr>
                                            <th className="border px-4 py-2">Producto</th>
                                            <th className="border px-4 py-2">Cantidad</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {datosDetalleComandaDB.length > 0 ? (
                                            datosDetalleComandaDB.map((detalle, index) => (
                                                <tr key={index}>
                                                    <td className="border px-4 py-2">{detalle.nombre_producto}</td>
                                                    <td className="border px-4 py-2">{detalle.cantidad_producto}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="border px-4 py-2 text-center">No hay detalles para esta comanda</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className='flex justify-start w-full'>
                <Grillaboordersreports/>
            </div>
        </div>
                 
    )
}
export default Bodygestioncomandas
